import { render, staticRenderFns } from "./Activity9.vue?vue&type=template&id=c0acf93a&scoped=true"
import script from "./Activity9.vue?vue&type=script&lang=js"
export * from "./Activity9.vue?vue&type=script&lang=js"
import style0 from "./Activity9.vue?vue&type=style&index=0&id=c0acf93a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0acf93a",
  null
  
)

export default component.exports